import { useMutation } from '@tanstack/react-query';
import { AdminOnboardingStepper } from '@/bundle/Auth/AdminOnboardingFlow/ui/AdminOnboardingStepper';
import { AuthLayout } from '@/bundle/Auth/ui/AuthLayout/AuthLayout';
import { useAdminOnboardingFlowFromAuthToken } from '@/bundle/shared/hooks/useAdminOnboardingFlowFromAuthToken';
import { AdminCompleteRegistrationForm } from '@/bundle/Auth/AdminOnboardingFlow/AdminCompleteRegistrationPage/ui/AdminCompleteRegistrationForm';
import { adminCompleteRegistration } from './api/api';
import { amplitudeService } from '@/services/amplitudeService/amplitudeService';
import { AMPLITUDE_EVENTS } from '@/services/amplitudeService/amplitudeEvents';
import { useAuthNavigateToStep } from '../../hooks/useAuthNavigateToStep';
import { AdminCompleteRegistrationPayloadType } from '@/api/v1/users/adminCompleteRegistrationApi';

export const AdminCompleteRegistrationPage = () => {
  const navigateToStep = useAuthNavigateToStep();
  const { isOnboardingFlow, signUpStep } = useAdminOnboardingFlowFromAuthToken();

  const { mutate, data, isPending } = useMutation({
    mutationKey: ['admin_complete_registration'],
    mutationFn: (values: AdminCompleteRegistrationPayloadType) => {
      return adminCompleteRegistration(values);
    },
    onSuccess(response) {
      if (response?.error) return;

      amplitudeService.logEvent(AMPLITUDE_EVENTS.CompleteRegistration);

      return navigateToStep(response?.body);
    },
  });

  return (
    <AuthLayout banner={isOnboardingFlow && <AdminOnboardingStepper signUpStep={signUpStep} />}>
      <AdminCompleteRegistrationForm onConfirm={mutate} isLoading={isPending} error={data?.error} />
    </AuthLayout>
  );
};
